// API Configuration for different environments
const ENV_OVERRIDE = process.env.REACT_APP_API_BASE_URL;

const getBaseUrl = () => {
  // 1) Explicit override via env (preferred in CI/preview if needed)
  if (ENV_OVERRIDE && ENV_OVERRIDE.trim() !== '') {
    return ENV_OVERRIDE.trim();
  }

  const { hostname, port, origin } = window.location;
  const isLocalhost = hostname === 'localhost' || hostname === '127.0.0.1';

  // 2) Local development with CRA dev server
  if (isLocalhost && port === '3000') {
    return '';
  }

  // 3) IDE/preview running on 127.0.0.1 but NOT the CRA dev server
  // Use same-origin so the preview proxy forwards /api/* correctly
  if (isLocalhost) {
    return origin;
  }

  // 4) Production Hosting – use same origin (rewrites map /api/* to Functions)
  return origin;
};

export const API_BASE_URL = getBaseUrl();
